import * as React from 'react'
import { Route, Switch } from 'react-router-dom'
import HomePage from './pages/home'
import ServicesPage from './pages/services'
import EmployeesPage from './pages/employees'
import LoginPage from './pages/login'
import BookingConfirmationPage from './pages/bookingConfirmation'
import AvailableTimesPage from './pages/availableTimes'
import ResetPasswordPage from './pages/resetPassword'
import UserBookingsPage from './pages/userBookings'
import ProfilePage from './pages/profile'
import { RouteType } from './types/routes'
import { CancelAppointmentPage } from './pages/cancelAppointment'
import ConfirmEmailPage from './pages/confirmEmail'
import RescheduleAppointmentPage from './pages/rescheduleAppointment'

const Routes: React.FC = () => {
  return (
    <Switch>
      {/* home */}
      <Route exact path={RouteType.Home} component={HomePage} />

      {/* workflow */}
      <Route path={RouteType.Employees} component={EmployeesPage} />
      <Route path={RouteType.Services} component={ServicesPage} />
      <Route path={RouteType.AvailableTimes} component={AvailableTimesPage} />
      <Route path={RouteType.BookingConfirmation} component={BookingConfirmationPage} />

      {/* auth */}
      <Route path={RouteType.Login} component={LoginPage} />
      <Route path={RouteType.ResetPassword} component={ResetPasswordPage} />
      <Route path={RouteType.ConfirmEmail} component={ConfirmEmailPage} />

      {/* user */}
      <Route path={RouteType.Profile} component={ProfilePage} />
      <Route path={RouteType.UserBookings} component={UserBookingsPage} />

      {/* appointments */}
      <Route path={RouteType.CancelAppointment} component={CancelAppointmentPage} />
      <Route path={RouteType.RescheduleAppointment} component={RescheduleAppointmentPage} />

      {/* 404 */}
      <Route component={() => <div>Not Found</div>} />
    </Switch>
  )
}

export default Routes
